export enum MainCategoryType {
  DISH = 'dish',
  BEVERAGE = 'beverage',
  OTHER = 'other',
}
